import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
var NavigationContent = function(param) {
    var render = param.render, children = param.children;
    return render(children);
};
export default function useComponent(render) {
    var renderRef = React.useRef(render);
    // Normally refs shouldn't be mutated in render
    // But we return a component which will be rendered
    // So it's just for immediate consumption
    renderRef.current = render;
    React.useEffect(function() {
        renderRef.current = null;
    });
    return React.useRef(function(param) {
        var children = param.children;
        var _$render = renderRef.current;
        if (_$render === null) {
            throw new Error("The returned component must be rendered in the same render phase as the hook.");
        }
        return /*#__PURE__*/ _jsx(NavigationContent, {
            render: _$render,
            children: children
        });
    }).current;
}
